import React from 'react';
import { Container, Grid } from '@mui/material';
import './aboutStyle.css'
import { FaFacebookMessenger } from 'react-icons/fa';


const AboutUsPage = () => {


    return (
        <>
            <Container maxWidth="lg" component="main" >
                <Grid container style={{ marginTop: "6rem", textAlign: "center" }}>

                    <Grid item md={12} sm={12} xs={12}>
                        <div className="contact-address-area" >
                            <div className="container">
                                <div className="sec-title-style1">
                                    <div className="title" style={{ color: "#0ea04e", fontSize: "2.5rem", fontWeight: "600", marginBottom: "1rem" }}>Contact Us</div>
                                    <div className="text" style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "1rem", color: "#f58320", marginBottom: "1.5rem" }}>
                                        <div className="decor-left" style={{ width: "50px", height: "2px", backgroundColor: "#f58320" }}></div>
                                        <p style={{ margin: "0", fontSize: "1.2rem", fontWeight: "500" }}>Quick Contact</p>
                                        <div className="decor-right" style={{ width: "50px", height: "2px", backgroundColor: "#f58320" }}></div>
                                    </div>
                                    <div className="bottom-text">
                                        <p style={{
                                            wordBreak: "normal",
                                            whiteSpace: "normal",
                                            fontSize: "1.1rem",
                                            color: "#333",
                                            maxWidth: "800px",
                                            margin: "0 auto",
                                            lineHeight: "1.6"
                                        }}>At Jaman Enterprise, we are passionate about providing top-notch home kitchen appliances and services. We value your experience and are committed to providing excellent customer service.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Grid>
                </Grid >
                <Grid container style={{ textAlign: "center" }}>

                    <Grid item md={4} sm={12} xs={12}>
                        <div style={{
                            backgroundColor: "#fff",
                            borderRadius: "12px",
                            padding: "2rem",
                            height: "100%",
                            boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                            transition: "transform 0.2s ease",
                            cursor: "pointer",
                            transform: "translateY(0)"
                        }}
                            onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                            onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}
                        >
                            <h3 style={{ color: "#0ea04e", marginBottom: "1.5rem", fontSize: "1.5rem" }}>Write to Us</h3>
                            <a href="mailto:sales@jamanenterprise.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    color: "#f58320",
                                    textDecoration: "none",
                                    fontSize: "1.1rem"
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.textDecoration = "underline"}
                                onMouseLeave={(e) => e.currentTarget.style.textDecoration = "none"}
                            >
                                sales@jamanenterprise.com
                            </a>
                        </div>
                    </Grid>
                    <Grid item md={4} sm={12} xs={12}>
                        <div style={{
                            backgroundColor: "#fff",
                            borderRadius: "12px",
                            padding: "2rem",
                            height: "100%",
                            boxShadow: "0 4px 6px rgba(0,0,0,0.1)"
                        }}>
                            <h3 style={{ color: "#0ea04e", marginBottom: "1.5rem", fontSize: "1.5rem" }}>Office Hours</h3>
                            <div style={{ color: "#333" }}>
                                <div style={{ marginBottom: "1.5rem" }}>
                                    <h4 style={{ color: "#f58320", marginBottom: "0.5rem" }}>Address:</h4>
                                    <p style={{ margin: 0, lineHeight: "1.6" }}>Near old Cinema house, Hariharpara, Murshidabad,<br />WB, 742166 4</p>
                                </div>
                                <div style={{ marginBottom: "1.5rem" }}>
                                    <h4 style={{ color: "#f58320", marginBottom: "0.5rem" }}>Ph & Email:</h4>
                                    <p style={{ margin: 0, lineHeight: "1.6" }}>+123 456 789<br />sales@jamanenterprise.com</p>
                                </div>
                                <div>
                                    <h4 style={{ color: "#f58320", marginBottom: "0.5rem" }}>Office Hrs:</h4>
                                    <p style={{ margin: 0, lineHeight: "1.6" }}>Mon-Sat: 9:30am - 9:30pm<br />Friday: 3pm-9:30pm</p>
                                </div>
                            </div>
                        </div>
                    </Grid>
                    <Grid item md={4} sm={12} xs={12}>
                        <div style={{
                            backgroundColor: "#fff",
                            borderRadius: "12px",
                            padding: "2rem",
                            height: "100%",
                            boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center"
                        }}>
                            <h3 style={{ color: "#0ea04e", marginBottom: "1.5rem", fontSize: "1.5rem" }}>Chat with Us</h3>
                            <a href='https://www.facebook.com/jamanenterprise.in'
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ transition: "transform 0.2s ease" }}
                                onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.1)"}
                                onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
                            >
                                <FaFacebookMessenger color="#f58320" size="50" />
                            </a>
                        </div>
                    </Grid>

                </Grid >

                <Grid container style={{ marginTop: "3rem" }}>
                    <Grid item xs={12} sm={12} md={12}>
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d910.9107230086636!2d88.41810502936094!3d24.04365499999999!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f961cd733f83d7%3A0x4b56f31a1446a835!2sJaman%20Enterprise!5e0!3m2!1sen!2sin!4v1707557224697!5m2!1sen!2sin"
                            width="100%"
                            height="450"
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            style={{ borderRadius: "12px", border: "none", boxShadow: "0 4px 6px rgba(0,0,0,0.1)" }}
                        ></iframe>
                    </Grid>
                </Grid>
            </Container >
        </>
    );
};

export default AboutUsPage;
